import { api } from '@/f1/service';

//restful api
//import { wmds as ws } from '@/f1/service/api'

export default {
  components: { },
  watch: {
    item() {
      this.load_image()
    }
  },
  data: () => {
    return {
      loading : true,
      start : true,
      img : '',
      colors : [
        "text-primary",
        "text-secondary",
        "text-success",
        "text-warning",
        "text-danger",
        "text-info",
        "text-light",
        "text-dark"
      ]
    }
  },
  computed : {
  },
  props: ['item', 'index'],
  methods: {
    load_image() {
      let so = {
        target : 'site', cmd : 'detail.thumbnail',
        body : { site_id : this.item.id },
      }
      // 이미지 로드의 경우, 한번 로딩 이슈 브라우저 캐시를 사용하게 됨
      // 받아오는 이미지의 경우도 처리가 된 경우임
      // 사이트 아이디가 있을 경우 점검 결과만 로드 함, 속도 이슈

      if(this.$route.params && this.$route.params.site_id) { return console.log('not load img') }
      return api.wmds.WMDS(so)
      //return ws.site.thumbnail(so)
        .then(rs => {
          this.img = rs && rs.body ? 'data:image/png;base64,'+rs.body : "img/no-image.png"; this.loading = false
          this.img + `?ts=${new Date().getTime()}`
        })
        .catch(e =>
          {
            this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
            this.img = 'img/no-image.png'
          }
        )
    },
    select(i) { this.$parent.$emit("click", i); },
  },
  destroyed () { console.log('Result.Grid.vue destroyed') },
  mounted () { console.log('Result.Grid.vue mounted'); this.$parent.$emit('load', 1); this.load_image() },
}